module.exports = __webpack_public_path__ + "img/partyMem.296df14d.png";